import React from 'react';
import { Calendar, Mail } from 'lucide-react';
import { authAxios, apiErrorMessage } from '@/lib/api';
import { isOverdue } from './crmConstants';

export default function FollowUpSection({ inquiry, today, onChange }) {
  const sendReminder = async () => {
    try {
      await authAxios.post(`/api/inquiries/${inquiry.id}/send-reminder`);
      alert('Reminder email sent!');
    } catch (e) {
      alert('Failed: ' + apiErrorMessage(e));
    }
  };

  return (
    <div className="bg-cream/30 border border-earth/8 rounded-lg p-3 mb-4" data-testid="follow-up-section">
      <div className="flex items-center justify-between">
        <p className="text-[10px] uppercase tracking-wider text-earth/40 font-sans font-semibold flex items-center gap-1"><Calendar size={10} /> Follow-up Date</p>
        <div className="flex items-center gap-2">
          {isOverdue(inquiry, today) && (
            <span className="text-[9px] text-red-500 font-sans font-bold uppercase px-2 py-0.5 bg-red-50 rounded" data-testid="follow-up-overdue">Overdue</span>
          )}
          {inquiry.follow_up_date && (
            <button
              onClick={sendReminder}
              className="text-[9px] text-amber-600 font-sans font-semibold px-2 py-0.5 bg-amber-50 border border-amber-200 rounded hover:bg-amber-100 transition-colors flex items-center gap-1"
              data-testid="send-reminder-btn"
            >
              <Mail size={9} /> Send Reminder
            </button>
          )}
        </div>
      </div>
      <input
        type="date"
        value={inquiry.follow_up_date || ''}
        onChange={(e) => onChange(e.target.value)}
        className="mt-1 border border-earth/15 rounded-md px-3 py-1.5 text-sm font-sans text-earth-dark focus:outline-none focus:ring-2 focus:ring-saffron/30 bg-white w-full"
        data-testid="follow-up-input"
      />
    </div>
  );
}
